import type { Character } from '@guildrise/shared';
import rankTable from './profile-ranks.csv?raw';

// Display-only snapshot of data/ranks.csv from the 2026-10-31 backup.
// It labels preserved guild levels; it does not award progress or unlock mechanics.
const ranks = rankTable
  .trim()
  .split(/\r?\n/)
  .slice(1)
  .map((line) => {
    const [, from, to, label] = line.split(',');
    return { from: Number(from), to: Number(to), label };
  });

export function profileRank(level: number): string {
  if (!Number.isInteger(level)) return '—';
  return ranks.find(({ from, to }) => level >= from && level <= to)?.label ?? '—';
}

export function collectionSummary(catalog: readonly Character[], ownedIds: readonly string[]) {
  const owned = new Set(ownedIds);
  return {
    owned: catalog.filter(({ character_id }) => owned.has(character_id)).length,
    total: catalog.length,
  };
}
